import { resolveReviewPromptPlatform } from '@shared/core/billing'
import { GetProfileResponseDto } from '@shared/core/users'
import { useQuery } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { UserEventsService } from 'src/services/user-events.service'
import { G2CapterraReviewAlertState } from '../alerts.types'

export const G2_REVIEW_PROMPT_CAPACITY_CACHE_KEY = 'g2-review-prompt-capacity'

export function useG2CapterraReviewAlertContext(profile: GetProfileResponseDto | null): {
  state: G2CapterraReviewAlertState
} {
  const reviewPlatform = resolveReviewPromptPlatform(profile?.subscription_plan_id)
  const handleRetry = useHandleRetry()

  const capacityQuery = useQuery(
    [G2_REVIEW_PROMPT_CAPACITY_CACHE_KEY],
    () => UserEventsService.getG2ReviewPromptCapacity(),
    {
      enabled: reviewPlatform === 'g2',
      staleTime: 300_000,
      retry: handleRetry,
    },
  )

  const isG2PromptCapReached =
    reviewPlatform === 'g2' ? capacityQuery.isError || capacityQuery.data?.capReached === true : false

  return {
    state: {
      isG2PromptCapReached,
      reviewPlatform,
      isG2CapacityLoading: reviewPlatform === 'g2' && capacityQuery.isLoading,
    },
  }
}
